<template>
	<div
		ref="projectList"
		class="project-list d-flex flex-column"
	>
		<search-bar v-model="filter" />

		<b-input-group :prepend="$t('projectlist.sort-by')">
			<b-form-select v-model="sortBy">
				<b-form-select-option value="recent">
					{{ $t('projectlist.sorting.recent') }}
				</b-form-select-option>
				<b-form-select-option value="name">
					{{ $t('projectlist.sorting.name') }}
				</b-form-select-option>
				<b-form-select-option value="location">
					{{ $t('projectlist.sorting.location') }}
				</b-form-select-option>
			</b-form-select>
			<b-input-group-addon>
				<b-button
					variant="default"
					@click="sortAscending = !sortAscending"
				>
					<b-icon :icon="sortAscending ? 'sort-down' : 'sort-up'" />
				</b-button>
			</b-input-group-addon>
		</b-input-group>

		<div class="project-list-items">
			<center v-if="projectListStatus === 'loading'" class="p-5">
				<b-spinner type="grow" />
			</center>
			<project-list-item
				v-for="(project, index) in computedProjectList"
				v-else
				:key="project.id"
				:project="project"
				:index="index"
				@project-selected="onProjectSelected"
				@project-mutated="loadProjectList"
			/>
		</div>

		<b-button v-b-modal.createProject>
			{{ $t('projectlist.new-project') }}
		</b-button>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import ProjectListItem from './ProjectListItem.vue';

const compareFunctions = {
	recent: (projectA, projectB) => Date.parse(projectB.updatedAt) - Date.parse(projectA.updatedAt),
	name: (projectA, projectB) => projectA.name.localeCompare(projectB.name),
	location: (projectA, projectB) => projectA.location.localeCompare(projectB.location),
};

export default {
	name: 'ProjectList',
	components: {
		ProjectListItem,
	},
	data() {
		return {
			filter: '',
			sortAscending: true,
			sortBy: 'recent',
			projectListStatus: 'loading',
		};
	},
	computed: {
		computedProjectList() {
			const projects = this.$store.state.projectList
				.filter((project) => project.name.toLowerCase().match(this.filter.toLowerCase()))
				.sort(compareFunctions[this.sortBy]);
			if (this.sortAscending) projects.reverse();
			return projects;
		},
	},
	mounted() {
		this.loadProjectList();
	},
	methods: {
		...mapActions(['fetchProjectList']),
		async loadProjectList() {
			this.$store.dispatch('fetchProjectList').then(
				(response) => {
					if (response) {
						this.projectListStatus = 'loaded';
					} else {
						this.$bvToast.toast(this.$t('projectlist.error-loading'), {
							title: this.$t('projectlist.error-loading'),
							autoHideDelay: 5000,
							appendToast: false,
							variant: 'danger',
						});
					}
				},
				(error) => {
					this.$bvToast.toast(`${error}`, {
						title: this.$t('projectlist.error-loading'),
						autoHideDelay: 5000,
						appendToast: false,
						variant: 'danger',
					});
				}
			);
		},
		onProjectSelected(project) {
			// re-emit the event so the container can handle it
			this.$emit('project-selected', project);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';
.project-list {
	width: 18rem;
	position: relative;
	height: 100%;
	background-color: $body-bg;

	& > * {
		flex: 0;
	}

	.project-list-items {
		flex: 1;
		height: 0;
		overflow-y: auto;
		overflow-x: hidden;
	}
}
</style>
